import { ReviewResponse } from "@omni/types/api/reviews/bff/response/reviews.response";
import { ModelMapper } from "@omni/types/utils/modelMapper";
import { Translate } from "@omni/types/utils/translate";

export const ReviewsMapperBFF: ModelMapper<
    ReviewResponse,
    (t: Translate) => ReviewResponse
> = (model) => (t: Translate) => ({
    ...model,
    reviews: model.reviews.map((review) => ({
        ...review,
        author: {
            ...review.author,
            name:
                review.author.name ||
                t("product.reviews.review.author.name.anonymous")
        }
    }))
});
